import { randomId } from "@mantine/hooks";
import { Fragment } from "react";
import MedicalInput from "src/components/pages/Settings/YachtSetUp/MedicalHistory/Inputs/MedicalInput";
import { StyledMedicalContentLabel } from "src/components/pages/Settings/YachtSetUp/MedicalHistory/MedicalHistory.styled";

import { type IMedicalOthersSection } from "../MedicalSections.model";
import MedicalSectionWrapper from "../MedicalSectionWrapper";
const MedicalStandalone = ({ name, rows }: IMedicalOthersSection) => {
  return (
    <MedicalSectionWrapper name={name}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "10px",
        }}>
        {rows.map(row => (
          <div
            key={randomId()}
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(2,1fr)",
              alignItems: "center",
              gap: "10px",
            }}>
            {row.inputs.map(input => (
              <Fragment key={input.name + Math.random()}>
                <StyledMedicalContentLabel>
                  {input.label}:
                </StyledMedicalContentLabel>
                <MedicalInput {...input} />
              </Fragment>
            ))}
          </div>
        ))}
      </div>
    </MedicalSectionWrapper>
  );
};
export default MedicalStandalone;
